import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MultiSelectorComponent} from './multi-selector.component';
import {SelectorValueDirective} from './selector-value.directive';

@NgModule({
  declarations: [MultiSelectorComponent, SelectorValueDirective],
  imports: [CommonModule],
  exports: [MultiSelectorComponent, SelectorValueDirective],
})
export class MultiselectorModule {}
